import type { SxProps, Theme } from '@portals/core/src/themes/themes';

export const getStyles = (theme: Theme, color: string): { [key: string]: SxProps } => {
  return {
    avatarStyles: {
      display: 'flex',
      justifyContent: 'center',
      alignContent: 'center',
      backgroundColor: color,
      width: { xs: '18px', lg: '24px' },
      height: { xs: '18px', lg: '24px' },

      '.MuiButton-root:hover &, .MuiButton-root:active &, .MuiButton-root[aria-current="page"] &, .MuiButton-root[aria-current="location"] &, .MuiButton-root[aria-selected="true"] &':
        {
          backgroundColor: color,
        },
    },
    icon: {
      fill: theme.palette.secondary.contrastText,
      fontSize: { xs: '12px', lg: '14px' },
    },
  };
};
